import React from 'react'
import ReactPaginate from 'react-paginate'

import Button from '../Button/Button'

import './pagination.css'

const Pagination = ({ onPageChange = () => {}, pageCount, page }) => (
  <ReactPaginate
    className='pagination'
    containerClassName='pagination__container'
    pageClassName='pagination__page'
    breakLabel="..."
    nextLabel={<Button.Arrow styles={{ width: 35, height: 35 }} />}
    onPageChange={onPageChange}
    marginPagesDisplayed={1}
    pageRangeDisplayed={1}
    pageCount={pageCount}
    forcePage={page - 1}
    previousLabel={<Button.Arrow styles={{ width: 35, height: 35 }} left />}
    renderOnZeroPageCount={null}
  />
)

export default Pagination
